import { createSlice } from "@reduxjs/toolkit";
import { postChatbotApi } from "../services/chatbot.service";

const initialState = {
  postResp: null,
  chatbotLoader: false,
  chatbotErrorMsg: "",
  chatbotIsTyping: false,
};

const Chatbot = createSlice({
  name: "chatbot",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postChatbotApi.pending, (state, action) => {
        state.chatbotLoader = true;
        state.chatbotIsTyping = true;
      })
      .addCase(postChatbotApi.fulfilled, (state, action: any) => {
        state.chatbotLoader = false;
        state.chatbotIsTyping = false;
        if (action.payload && action.payload?.data) {
          state.postResp = action.payload?.data;
        }
      })
      .addCase(postChatbotApi.rejected, (state, action: any) => {
        state.chatbotIsTyping = false;
        state.chatbotLoader = false;
        state.chatbotErrorMsg = action.error.message
          ? action?.error?.message
          : "Seems like our Chatbot is having issues reaching to you.";
      });
  },
});

export default Chatbot.reducer;
